import React from "react";
import { DropdownCommandMenuProps } from "./Dropdown.types";
import { Tabs } from "../Tabs";
import * as S from "./CommandMenu.styles";
import { Root } from "./Root";
import { Trigger } from "./Trigger";
import { Portal } from "@radix-ui/react-dropdown-menu";
import { Chevron } from "./Trigger";

/**
 * CommandMenu component for the Dropdown menu
 *
 * @param props - The component props
 * @returns A Dropdown CommandMenu component
 */
export const CommandMenu: React.FC<DropdownCommandMenuProps> = ({
  triggerLabel,
  headerContent,
  tabs = [],
  disabled = false
}) => {
  return (
    <Root>
      <Trigger variant="outline" disabled={disabled}>
        {triggerLabel} <Chevron />
      </Trigger>
      <Portal>
        <S.Contend align="end">
          <Tabs.Root
            defaultValue={
              tabs.find(item => item?.default)?.id || tabs[0].id || tabs[0].id
            }
          >
            <S.HeaderContent>
              <Tabs.List aria-label="tabs-dropdown">
                {tabs.map(tab => (
                  <Tabs.Trigger
                    key={`${tab.id}_label`}
                    data-orientation="horizontal"
                    variant="command_menu"
                    value={tab.id}
                  >
                    {tab.label}
                  </Tabs.Trigger>
                ))}
              </Tabs.List>
              {headerContent}
            </S.HeaderContent>
            <S.Separator />
            {tabs.map(tab => (
              <Tabs.Content key={`${tab.id}_content`} value={tab.id}>
                {tab.component}
              </Tabs.Content>
            ))}
          </Tabs.Root>
        </S.Contend>
      </Portal>
    </Root>
  );
};
